import {
  AutopilotTaskDto,
  TaskCategoryTaskType,
} from '@urbanx/agx.activities.client'
import { AgxEmptyState, AgxSpacer } from '@urbanx/agx.ui-components2'
import { Pages } from 'constants/menu'
import { JSX } from 'react'
import { useNavigate } from 'react-router-dom'

interface NoLaunchDateBlockerProps {
  task: AutopilotTaskDto
}

export const NoLaunchDateBlocker = ({ task }: NoLaunchDateBlockerProps): JSX.Element => {
  const navigate = useNavigate()
  const taskName =
    task.category?.taskType === TaskCategoryTaskType.Launch
      ? 'Launch'
      : 'Pre-Launch'

  return (
    <AgxSpacer
      fill
      contentJustification="center"
      contentAlignment="center"
    >
      <AgxEmptyState
        variant="advanced"
        glyphType="locked"
        actionButtons={[
          {
            label: 'Set Launch Date',
            isPrimary: true,
            order: 1,
            onClick: function (): void {
              navigate?.(
                `/${Pages.AGENCIES}/${task.agencyId}/campaigns/${task?.campaignId}/campaign-marketing`
              )
            },
          },
        ]}
        label="No Launch Date Set"
        description={`Once a launch date is set, you can complete ${taskName}.`}
      />
    </AgxSpacer>
  )
}
